<div class="col-md-12">
      <div class="assign-section">
        <div class="col-md-4">
            <mat-form-field appearance="none" class="form-control search-div">
              <input matInput placeholder="Search by Scheduler Name" [(ngModel)]="searchKey" (keyup)="getSchedulers()"
                #input>
              <button mat-button matSuffix mat-icon-button arai-label="Clear" *ngIf="searchKey" (click)="onSearchClear()"
                class="mat-icon-button">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <button mat-raised-button class="btn Action-buttons" *ngIf="!searchKey" style="background-color: transparent; border: none; z-index:1;
                      box-shadow: 0 0 black;
                      position: absolute;
                      left: 275px;
                      top: 12px;">
              <mat-icon>search</mat-icon>
            </button>
        </div>

        <div class="col-md-4"></div>
        <div class="col-md-4 search-bx-outer">
          <div class="schedule-div1">
            <button mat-raised-button class="btn btn-icon-text3 act-btn" [disabled]="isTargetButtonDisabled"
              (click)="openAssigntargetDialog()">
              <i class="fa fa-check-square" aria-hidden="true"></i> &nbsp; Assign Target</button>
          </div>
          <div class="schedule-div1">
            <button mat-raised-button class="btn btn-icon-text3 act-btn" [disabled]="isAssignButtonDisabled"
              (click)="openAssignDialog()">
              <i class="fa fa-user-plus" aria-hidden="true"></i> &nbsp; Assign/Deassign</button>
          </div>
        </div>
      </div>
</div>

<div class="col-lg-12 grid-margin stretch-card paddrl35" style="padding-bottom: 20px;">
  <div class="card Member-card">
    <table mat-table matSort [dataSource]="dataSource" aria-label="Elements" class="display nowrap mat-elevation-z0" style="width:100%"
    name="search">

    <!-- Selected Column -->
    <ng-container matColumnDef="selection">
      <mat-radio-group appearance="fill">
        <th mat-header-cell *matHeaderCellDef> &nbsp; </th>
        <td mat-cell *matCellDef="let row">
          <mat-radio-button [value]="row" (click)="radiobuttonClick($event, row)"
            color="primary">
          </mat-radio-button>
        </td>
      </mat-radio-group>
    </ng-container>

    <!-- Scheduler ID Column -->
    <ng-container matColumnDef="schedulerId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>User Id</th>
      <td mat-cell *matCellDef="let element">{{element.schedulerId}}</td>
    </ng-container>

    <!-- First Name Column -->
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
      <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
    </ng-container>

    <!-- Last Name Column -->
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
      <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
    </ng-container>

     <!-- ContactNumber Column -->
     <ng-container matColumnDef="contactNumber">
      <th mat-header-cell *matHeaderCellDef>Contact Number</th>
      <td mat-cell *matCellDef="let element">{{element.contactNumber}}</td>
    </ng-container>

    <!-- Address1 Column -->
    <ng-container matColumnDef="address1">
      <th mat-header-cell *matHeaderCellDef>Address Line 1</th>
      <td mat-cell *matCellDef="let element">{{element.address1}}</td>
    </ng-container>

    <!-- Address2 Column -->
    <ng-container matColumnDef="address2">
      <th mat-header-cell *matHeaderCellDef>Address Line 2</th>
      <td mat-cell *matCellDef="let element">{{element.address2}}</td>
    </ng-container>

    <!-- State Column -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef>State</th>
      <td mat-cell *matCellDef="let element">{{element.state}}</td>
    </ng-container>

    <!-- City Column -->
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
      <td mat-cell *matCellDef="let element"> {{element.city}} </td>
    </ng-container>

    <!-- Zip Column -->
    <ng-container matColumnDef="zip">
      <th mat-header-cell *matHeaderCellDef>Zip</th>
      <td mat-cell *matCellDef="let element">{{element.zip}}</td>
    </ng-container>

    <!-- Client Name Column -->
    <ng-container matColumnDef="clientName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Name</th>
      <td mat-cell *matCellDef="let element">{{element.clientName}}</td>
    </ng-container>

    <!-- Project Name Column -->
    <ng-container matColumnDef="assignedProjectNames">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Name</th>
      <td mat-cell *matCellDef="let element">{{element.assignedProjectNames}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- Display loading data -->
  </table>

  <mat-paginator #paginator [showFirstLastButtons]="true" [length]="length" [pageSize]="pageSize"
  [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = getSchedulers($event)"
  class="mat-paginator12 mat-paginator-sticky">
  </mat-paginator>
  </div>

</div>
